import { useContextLocalization } from "@/app/module/localization/index";
import { Text, TextProps } from "@/base/components/index";
import { useMemo } from "react";

export type LocalizationMoneyProps = {
  value: number;
  currency?: string;
};

export const LocalizationMoney = ({
  value,
  currency,
  hasTextCmp = false,
  ...props
}: LocalizationMoneyProps & TextProps & { hasTextCmp?: boolean }) => {
  const { currentLang } = useContextLocalization();
  const style = useMemo(() => ({ color: "inherit" }), []);

  const formattedValue = new Intl.NumberFormat(currentLang, {
    style: "currency",
    currency: currency || "USD",
  }).format(value || 0);

  return hasTextCmp ? (
    <Text style={style} {...props}>
      {formattedValue}
    </Text>
  ) : (
    formattedValue
  );
};
